<template>
  <li>
    <router-link
      :to="mainTo"
      v-if="mainTo"
      class="hover:bg-gray-200 active:bg-gray-200 focus:bg-gray-200 cursor-default"
    >
      <component
        :is="mainIcon"
        v-if="mainIcon"
        class="h-5 w-5"
        aria-hidden="true"
      />
      {{ mainLabel }}
    </router-link>
    <ul v-if="items && items.length > 0">
      <li v-for="(item, index) in items" :key="index">
        <router-link :to="item.to" :class="getItemClass(item)" v-if="item.to">
          <component
            :is="item.icon"
            v-if="item.icon"
            class="h-5 w-5"
            aria-hidden="true"
          />
          {{ item.label }}
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
import { useRoute } from "vue-router";

export default {
  name: "NavMenuGroup",
  props: {
    mainTo: {
      type: String,
      required: true,
    },
    mainIcon: {
      type: [Object, Function],
      default: null,
    },
    mainLabel: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const route = useRoute();

    const getItemClass = (item) => {
      if (
        !route.name ||
        !item.activeRouteNames ||
        item.activeRouteNames.length === 0
      )
        return "";
      const isActive = item.activeRouteNames.some((name) => route.name === name);
      return isActive ? "bg-base-300" : "";
    };

    return {
      getItemClass,
    };
  },
};
</script>
